import { KiwiMark } from "./KiwiMark";

const LINKS = [
  { label: "Home", hash: "#home" },
  { label: "About", hash: "#about" },
  { label: "Programs", hash: "#programs" },
  { label: "Activities", hash: "#activities" },
  { label: "Parent Feedback", hash: "#feedback" },
  { label: "Franchise", hash: "#franchise" },
  { label: "Contact", hash: "#contact" },
];

export const Footer = () => {
  const go = (e, hash) => {
    e.preventDefault();
    window.__lenis
      ? window.__lenis.scrollTo(hash, { offset: -80, duration: 1.4 })
      : document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer-section" className="relative bg-forest text-cream overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-16 pb-10">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <KiwiMark className="w-11 h-11" />
              <span className="leading-none">
                <span className="block font-play font-semibold text-xl">Kiwi Kids</span>
                <span className="block text-[10px] tracking-[0.28em] uppercase text-sun font-semibold mt-1">
                  Pre-School
                </span>
              </span>
            </div>
            <p className="mt-5 font-quote italic text-xl text-cream/80">
              Little steps. Big beginnings.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-[0.24em] uppercase text-sun mb-5">Explore</h4>
            <ul className="grid grid-cols-2 gap-x-6 gap-y-3">
              {LINKS.map((l) => (
                <li key={l.hash}>
                  <a
                    href={l.hash}
                    onClick={(e) => go(e, l.hash)}
                    className="text-sm text-cream/70 hover:text-sun transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold tracking-[0.24em] uppercase text-sun mb-5">Reach Us</h4>
            <ul className="space-y-3.5 text-sm text-cream/70">
              <li>
                <a href="tel:+919711245316" className="hover:text-sun transition-colors">
                  +91 97112 45316
                </a>
              </li>
              <li>
                <a
                  href="mailto:kiwikids.playschool1@gmail.com"
                  className="hover:text-sun transition-colors break-all"
                >
                  kiwikids.playschool1@gmail.com
                </a>
              </li>
              <li>Manesar, Gurugram (Haryana)</li>
              <li>Sandila & Bharawan (Uttar Pradesh)</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <span>© 2026 Kiwi Kids Pre-School. All rights reserved.</span>
          <span>Nurturing curiosity, every single day.</span>
        </div>
      </div>
    </footer>
  );
};
